import { useState } from 'react';
import classNames from 'classnames';
import { RoadmapForm } from '@sapientpro/sapientpro-data-models';
import styles from './SurveySection.module.scss';

export type TSurveyQuestion = RoadmapForm['tabs'][number];

export type TSurveyAnswer = RoadmapForm['tabs'][number]['attributes'][number];

interface ISurveyQuestionProps {
  question: TSurveyQuestion;
  handleActiveChange: () => void;
  handleAnswerChange: (answer: TSurveyAnswer, questionKey: TSurveyQuestion['analyticsValue']) => void;
  isActive: boolean;
  formView?: boolean;
}

const SurveyQuestion = ({
  question,
  handleActiveChange,
  handleAnswerChange,
  formView,
  isActive,
}: ISurveyQuestionProps) => {
  const [activeAnswer, setActiveAnswer] = useState<number>(0);

  const handleAnswerSelect = (answer: TSurveyAnswer) => {
    const isSelected = activeAnswer === answer.id;

    if (isSelected) {
      setActiveAnswer(0);
    } else {
      setActiveAnswer(answer.id);
    }

    handleAnswerChange(answer, question.analyticsValue);
  };

  return (
    <div
      className={classNames(styles.surveyQuestion, {
        [styles.active]: isActive,
      })}
    >
      <button
        type='button'
        className={styles.question}
        onClick={() => handleActiveChange()}
      >
        <p className={classNames(styles.questionText, 'header3')}>{question.title}</p>
        <svg className={styles.questionIcon}>
          <use
            xlinkHref='/media/icon-nest.svg#iconNest'
            href='/media/icon-nest.svg#iconNest'
          />
        </svg>
      </button>
      <div className={classNames(styles.answerOptions, {
        [styles.visible]: formView,
      })}
      >
        {question.attributes.map((answer) => {
          const isActiveAnswer = activeAnswer === answer.id;

          return (
            <button
              key={answer.id}
              className={classNames(styles.surveyAnswer, 'bodyExtraSmall', {
                [styles.active]: isActiveAnswer,
              })}
              type='button'
              onClick={() => handleAnswerSelect(answer)}
            >
              {answer.title}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SurveyQuestion;
